import { Component, OnInit, Input } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-booking-steps',
  templateUrl: './booking-steps.component.html',
  styleUrls: ['./booking-steps.component.scss'],
})
export class BookingStepsComponent implements OnInit {
  active_step: string;
  fisiq = false;
  token: string;

  @Input()
  activeStep: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      const step = document.getElementById('step_' + this.activeStep);
    	const steps = document.getElementsByClassName('step');
      
      step.classList.remove('active');

      if (step) {
        step.classList.add('active');

        setTimeout(() => {

          for (let i = 0; i < steps.length; i++) {

            if (!steps[i].classList.contains('active')) {
              steps[i].classList.add('used');
            } else {
              break;
            }
          }
        }, 0);
      }

      if (params['bookingToken']) {
        this.token = params['bookingToken'];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/booking-steps/booking-steps.component.ts